import { emitter } from '../lib/utils';

export default class CollectionFilter {
  constructor({ el, isLargeQuery }) {
    this.form = el;
    this.isLargeQuery = isLargeQuery;

    // actual filtering
    this.checkboxes = Array.from(this.form.querySelectorAll('.filter-checkbox'));
    this.containerElString = this.form.getAttribute('data-container-el');
    this.productList = document.getElementById(this.containerElString);
    this.searchParamsInitial = window.location.search.slice(1);
    this.searchParamsPrev = window.location.search.slice(1);
    this.resetButtons = Array.from(this.form.querySelectorAll('.reset-button'));
    this.filterType = this.form.getAttribute('data-type');
    this.sectionToRender = this.filterType === 'collection' ? 'main-collection' : 'main-search';
    this.resetFilters = this.form.querySelectorAll('[data-filter-reset]');

    this.init();
  }

  init() {
    // filter checkboxes
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const params = this.getSearchParams();

        this.renderPage(params, true);
      });
    });

    this.resetFilters.forEach((resetFilter) => {
      resetFilter.addEventListener('click', async (e) => {
        e.preventDefault();

        const paramName = resetFilter.dataset.filterReset;

        const params = this.getSearchParams({
          paramToRemove: paramName,
        });

        this.renderPage(params, true);
      });
    });

    this.resetButtons.forEach((button) => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        await this.renderPage(false, true, true);
      });
    });

    window.addEventListener('popstate', this.onHistoryChange.bind(this));
  }

  async renderPage(searchParams, updateFilters = false, updateUrl = true) {
    if (this.form.classList.contains('is-mobile')) {
      emitter.emit('filters:close');
    }

    // set previous search params
    this.searchParamsPrev = searchParams;

    this.productList.style.opacity = '.3';

    if (updateUrl) this.updateUrl(searchParams);

    // check if search params is empty
    if (!searchParams || searchParams.filterParams.length === 0) {
      this.form.classList.add('hide-reset');
    } else {
      this.form.classList.remove('hide-reset');
    }

    // update form filters
    if (updateFilters) {
      this.checkboxes.forEach((checkbox) => {
        checkbox.classList.add('yup');
        // replace spaces with +
        const paramChecker = checkbox.dataset.paramChecker.replace(/\s+/g, '+');

        if (searchParams?.filterParams && searchParams.filterParams.includes(paramChecker)) {
          checkbox.checked = true;

          // hide nearest li
          checkbox.closest('li').classList.add('hidden');

          console.log(checkbox.closest('li'));

          // get nearest '.filter-group'
          const filterGroup = checkbox.closest('.filter-group');

          // get '.active-filter-item' inside filter group
          const activeFilterItem = filterGroup.querySelector('.active-filter-item p');
          const resetFilter = filterGroup.querySelector('.reset-filter');

          if (activeFilterItem) {
            activeFilterItem.textContent = checkbox.labels[0].textContent;
          }

          if (resetFilter) {
            resetFilter.classList.remove('hidden');
          }
        } else {
          checkbox.checked = false;
          checkbox.closest('li').classList.remove('hidden');
        }
      });

      // for each reset button, check if it's active
      this.resetFilters.forEach((resetFilter) => {
        const paramName = resetFilter.dataset.filterReset;

        if (searchParams?.filterParams && searchParams.filterParams.includes(paramName)) {
          resetFilter.classList.remove('hidden');
        } else {
          resetFilter.classList.add('hidden');

          const filterGroup = resetFilter.closest('.filter-group');
          const activeFilterItem = filterGroup.querySelector('.active-filter-item p');

          if (activeFilterItem) {
            activeFilterItem.textContent = 'All';
          }
        }
      });
    }

    // get filter url
    const url = `${window.location.pathname}?${searchParams.q ? `q=${searchParams.q}&type=product&` : ''}section_id=${
      this.sectionToRender
    }${searchParams.filterParams ? `&${searchParams.filterParams}` : ''}`;

    // fetch new products list via section rendering api
    await fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const resultsMarkup = new DOMParser().parseFromString(html, 'text/html');

        const productHTML = resultsMarkup.querySelector('#product-list').innerHTML;

        // update products list
        this.productList.innerHTML = productHTML;
        this.productList.style.opacity = '1';
      });
  }

  getSearchParams({ paramToRemove = null } = {}) {
    // check if there is a 'q' search param in url
    const url = new URL(window.location);
    const searchParams = url.searchParams;
    const q = searchParams.get('q');

    const formData = new FormData(this.form);

    // If paramToRemove is provided, remove it from formData
    if (paramToRemove) {
      formData.delete(paramToRemove);
    }

    return {
      q,
      filterParams: new URLSearchParams(formData).toString(),
    };
  }

  updateUrl(searchParams) {
    if (searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}?${
          searchParams.q ? `q=${searchParams.q}&type=product${searchParams.filterParams ? '&' : ''}` : ''
        }${searchParams.filterParams}`,
      );
    } else {
      history.pushState({}, '', `${window.location.pathname}`);
    }
  }

  onHistoryChange(e) {
    const searchParams = e.state ? e.state.searchParams : this.searchParamsInitial;
    if (searchParams === this.searchParamsPrev) return;
    this.renderPage(searchParams, true, false);
  }
}
